import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Paper from "@mui/material/Paper";
import ListItemText from "@mui/material/ListItemText";
import {BASE_URL_API, PRODUCT_BASE_URL_API} from "../Const";
import {Link} from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import ImageList from '@mui/material/ImageList';
import {BottomMenu,BackButton} from './HookUtils'
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import {BasketComponent} from "./BasketComponent";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import Inventory2Icon from "@mui/icons-material/Inventory2";

export class AllProductComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            productList: [],
        }
    }

    componentDidMount() {
        fetch(BASE_URL_API + 'product?market_id=' + this.props.market_id + '&child_category_id=' + this.props.child_category_id, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {
                    // Sort products: those with pictures first
                    const sortedProducts = results.data.sort((a, b) => {
                        return (b.pictures.length > 0 ? 1 : 0) - (a.pictures.length > 0 ? 1 : 0);
                    });
                    this.setState({ productList: sortedProducts });
                },
                (error) => {
                    console.log("error")
                }
            );
    }


    renderProductCard = (product) => {
        const MAX_LENGTH = 20;

        // Helpers (put near the component)
        const formatStep = (val) => {
            const num = Number(val);
            if (!isFinite(num) || num <= 0) return "";
            return parseFloat(num.toFixed(4)).toLocaleString("en", {maximumFractionDigits: 4});
        };

        const formatTomans = (val) =>
            Number(val || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " تومان ";

        return (
            <ListItem
                key={product.id}
                component={Link}
                to={"/product?id=" + product.id}
                sx={{
                    width: 150,
                    px: 0,
                    textDecoration: "none",
                    color: "inherit",
                }}
            >
                <Paper
                    elevation={1}
                    sx={{
                        width: "100%",
                        height: "100%",
                        borderRadius: 2,
                        p: 1.25,
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        transition: "transform 120ms ease, box-shadow 120ms ease",
                        "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: 3,
                        },
                    }}
                >
                    {/* Image */}
                    <Box
                        sx={{
                            width: 140,
                            height: 140,
                            borderRadius: 1.5,
                            overflow: "hidden",
                            bgcolor: "#ffffff",
                            display: "flex",               // ✅ enables flexbox
                            alignItems: "center",          // ✅ vertical centering
                            justifyContent: "center",      // ✅ horizontal centering
                        }}
                    >
                        <Box
                            component="img"
                            alt={product.title}
                            src={
                                product.pictures.length > 0
                                    ? PRODUCT_BASE_URL_API + product.pictures[0].url
                                    : "hamekara-logo.png"
                            }
                            sx={{
                                maxWidth: "100%",            // ✅ prevents overflow
                                maxHeight: "100%",           // ✅ keeps proportions
                                objectFit: "contain",        // ✅ avoids deformation
                                display: "block",
                            }}
                        />
                    </Box>


                    {/* Title */}
                    <Typography
                        variant="body2"
                        sx={{
                            fontWeight: 700,
                            color: "text.primary",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            direction: "rtl",
                        }}
                        title={product.title}
                    >
                        {product.title.length > MAX_LENGTH
                            ? `${product.title.substring(0, MAX_LENGTH)}...`
                            : product.title}
                    </Typography>

                    {/* Inventory / تماس بگیرید */}
                    <Typography
                        variant="caption"
                        sx={{
                            lineHeight: 1.2,
                            color: Number(product.step) > 0 ? "text.secondary" : "error.main",
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            whiteSpace: "nowrap",
                            direction: "rtl",
                        }}
                    >
                        {Number(product.step) > 0 ? (
                            <>
                                <Inventory2Icon fontSize="inherit"/>
                                موجودی:&nbsp;{formatStep(product.step)}
                            </>
                        ) : (
                            "تماس بگیرید"
                        )}
                    </Typography>

                    {product.markets?.name && (
                        <Chip
                            label={product.markets.name}
                            size="small"
                            sx={{
                                display: "inline-flex",     // ✅ don't stretch full width
                                width: "fit-content",       // ✅ shrink to text
                                direction: "rtl",
                                fontSize: 11,
                                height: 22,
                                borderRadius: 1,
                                px: 0.8,
                                bgcolor: "grey.100",
                                color: "text.secondary",
                                "& .MuiChip-label": {
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    px: 0.5,
                                },
                            }}
                            title={product.markets.name}
                        />
                    )}


                    {/* Price / Discount */}
                    {Number(product.del_price) > 0 ? (
                        <Box sx={{mt: "auto"}}>
                            <Typography
                                variant="body2"
                                sx={{
                                    color: "text.secondary",
                                    textDecoration: "line-through",
                                    whiteSpace: "nowrap",
                                    direction: "rtl",
                                }}
                            >
                                <strong>{formatTomans(product.price)}</strong>
                            </Typography>

                            <Typography
                                variant="body1"
                                sx={{
                                    color: "success.main",
                                    fontWeight: 700,
                                    whiteSpace: "nowrap",
                                    direction: "rtl",
                                }}
                            >
                                <strong>
                                    {formatTomans(
                                        parseInt(product.price, 10) - parseInt(product.del_price, 10)
                                    )}
                                </strong>
                            </Typography>
                        </Box>
                    ) : (
                        <Box sx={{mt: "auto"}}>
                            <Typography
                                variant="body1"
                                sx={{
                                    color: Number(product.price) > 0 ? "success.main" : "warning.main",
                                    fontWeight: 700,
                                    whiteSpace: "nowrap",
                                    direction: "rtl",
                                }}
                            >
                                <strong>
                                    {Number(product.price) > 0
                                        ? formatTomans(product.price)
                                        : "تماس بگیرید."}
                                </strong>
                            </Typography>
                        </Box>
                    )}
                </Paper>
            </ListItem>
        );
    };


    render() {

        return (
            <div>
                <AppBar style={{background: 'rgba(238,238,238,0.3)', overflow: 'auto', display: 'flex'}}>
                    <ToolbarMui>

                        <ShoppingBasketOutlinedIcon style={{color: 'black'}}/>
                        {
                            this.state.productList.length > 0 ?

                                <ListItemText align="center"><strong style={{
                                    fontSize: 18,
                                    overflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    color: 'black'
                                }} >{this.state.productList[0].category.title}</strong></ListItemText>
                                : ""
                        }

                        <IconButton component={Link} to={"/search"} style={{color: 'black'}} size="large"><SearchIcon/></IconButton>

                        <IconButton style={{color: 'black'}} size="large"> <BasketComponent/></IconButton>

                        <BackButton/>
                    </ToolbarMui>

                </AppBar>
                {
                    <React.Fragment>
                        <div style={{
                            marginTop: 80,
                            marginBottom: 80,
                            padding: 12,
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            gap: 12,
                        }}>
                            {this.state.productList.map((product) => (
                                this.renderProductCard(product)
                            ))}
                        </div>

                        <BottomMenu />
                    </React.Fragment>

                }
            </div>
        );

    }

}
